import { Alert, ConfigProvider, Flex, Image, Typography } from "antd";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { useUserType } from "hooks/useUserType";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dedent from "dedent";
import { useSystemMaintenance } from "hooks/useSystemMaintenance";

dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export const VacationAlert = () => {
  const { isAdminUser } = useUserType();
  const showBanner =
    dayjs
      .tz(dayjs.utc(), "Europe/Berlin")
      .isAfter(
        dayjs.utc(process.env.REACT_APP_BLOCK_FRONTEND_ACCESS_START_TIME_ISO).tz("Europe/Berlin")
      ) &&
    dayjs
      .tz(dayjs.utc(), "Europe/Berlin")
      .isBefore(
        dayjs.utc(process.env.REACT_APP_BLOCK_FRONTEND_ACCESS_END_TIME_ISO).tz("Europe/Berlin")
      );

  return (
    // showBanner &&
    !isAdminUser && (
      <ConfigProvider
        theme={{
          components: {
            Alert: {
              colorWarningBg: "#E75012"
            }
          }
        }}>
        <Alert
          // icon={<Image src="images/vacation-logo.png" style={{ maxWidth: 100 }} />}
          description={
            <Flex gap={16}>
              {/* <Image src="./images/vacation-logo.png" height={50} style={{ maxWidth: 100 }} /> */}
              <Flex vertical justify="center" align="center">
                {/* <Typography.Text>Bia is on Christmas break!</Typography.Text> */}
                <Typography.Text>
                  {dedent`Bia is undergoing upgrades to enhance performance and continued reliability. For inquiries, please contact us at `}{" "}
                  <a href="mailto:sales@quixquantum.com" style={{ color: "#fff" }}>
                    sales@quixquantum.com
                  </a>
                </Typography.Text>
              </Flex>
            </Flex>
          }
          type="warning"
          style={{
            width: "100%",
            // marginBottom: "8px",
            border: 0,
            borderRadius: 0,
            outline: "none"
          }}
        />
      </ConfigProvider>
    )
  );
};
